import gql from 'graphql-tag';
import moment from 'moment';
// import { FRAGMENT_CTA_BUTTON } from 'src/modules/global';

const currentDate = moment().format('YYYY-MM-DD');

export const QUERY_EVENTS = gql`
  query Events {
    events(where: {end_date_gte: "${currentDate}"}, sort: "start_date:asc") {
      name_en
      name_de
      description_en
      description_de
      start_date
      end_date
      button {
        ...ctaButton
      }
      image {
        url
        alternativeText
      }
    }
  }
  fragment ctaButton on ComponentCtaButton {
    text_en
    text_de
    url
    external_link
    isButton: button
    overlay
    download {
      url
    }
  }
`;
